import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Star, Piano, Guitar, Music, Drum, Mic } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Empecé con piano y ahora también toco guitarra. Tener todo en un solo método cambió la forma en que aprendo música.',
    name: 'María González',
    age: '58 años',
    instrument: 'Piano y guitarra',
    color: 'magenta'
  }, {
    quote: 'A los 65 empecé con batería y canto. Es adictivo, no puedo parar de aprender.',
    name: 'Jorge Fernández',
    age: '65 años',
    instrument: 'Batería y canto',
    color: 'cyan'
  }, {
    quote: 'Simple, claro y sin vueltas. Pasé de no saber nada a tocar mis primeras canciones.',
    name: 'Susana López',
    age: '47 años',
    instrument: 'Guitarra',
    color: 'violet'
  }];
  const borderColors: Record<string, string> = {
    magenta: 'border-magenta/25 hover:border-magenta/50',
    cyan: 'border-cyan/25 hover:border-cyan/50',
    violet: 'border-violet/25 hover:border-violet/50'
  };
  const dotColors: Record<string, string> = {
    magenta: 'bg-magenta drop-shadow-glow-magenta',
    cyan: 'bg-cyan drop-shadow-glow-cyan',
    violet: 'bg-violet drop-shadow-glow-violet'
  };
  return <section className="py-20 bg-navy relative overflow-hidden" data-id="element-268">
      <div className="absolute top-10 right-0 w-72 h-72 bg-magenta/10 rounded-full blur-3xl translate-x-1/3 pointer-events-none" data-id="element-269"></div>
      <div className="absolute top-1/2 left-1/2 w-72 h-72 bg-cyan/8 rounded-full blur-3xl pointer-events-none" data-id="element-270"></div>
      <div className="absolute bottom-10 left-0 w-56 h-56 bg-violet/10 rounded-full blur-3xl -translate-x-1/4 pointer-events-none" data-id="element-271"></div>
      <div className="absolute top-1/2 left-[60%] text-gold/[0.04] text-7xl font-serif select-none pointer-events-none" data-id="element-272">
        ♬
      </div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-273">
        <FadeIn data-id="element-274">
          <h2 className="text-3xl md:text-4xl font-black text-center text-beige mb-5" data-id="element-275">
            Lo que dicen{' '}
            <span className="text-gold drop-shadow-glow-gold" data-id="element-276">
              nuestros alumnos
            </span>
          </h2>

          {/* Instrument icons */}
          <div className="flex items-center justify-center gap-5 md:gap-7 mb-5" data-id="element-277">
            <Piano className="w-6 h-6 md:w-7 md:h-7 text-gold drop-shadow-glow-gold" data-id="element-278" />
            <Guitar className="w-6 h-6 md:w-7 md:h-7 text-magenta-light drop-shadow-glow-magenta" data-id="element-279" />
            <Music className="w-6 h-6 md:w-7 md:h-7 text-cyan drop-shadow-glow-cyan" data-id="element-280" />
            <Drum className="w-6 h-6 md:w-7 md:h-7 text-lime drop-shadow-glow-lime" data-id="element-281" />
            <Mic className="w-6 h-6 md:w-7 md:h-7 text-violet-light drop-shadow-glow-violet" data-id="element-282" />
          </div>

          <p className="text-center text-beige/60 mb-14 text-lg" data-id="element-283">
            Historias de éxito reales
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-284">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-285">
              <div className={`bg-navy-light border ${borderColors[testimonial.color]} p-7 rounded-2xl h-full flex flex-col transition-all`} data-id="element-286">
                <div className="flex gap-1 mb-5" data-id="element-287">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold drop-shadow-glow-gold" data-id="element-288" />)}
                </div>
                <p className="text-lg text-beige/85 italic mb-6 flex-grow leading-relaxed" data-id="element-289">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-beige/10 pt-4 flex items-center gap-3" data-id="element-290">
                  <span className={`w-2 h-2 rounded-full ${dotColors[testimonial.color]}`} data-id="element-291"></span>
                  <div data-id="element-292">
                    <p className="font-bold text-beige text-lg" data-id="element-293">
                      {testimonial.name}
                    </p>
                    <p className="text-beige/50 text-sm" data-id="element-294">
                      {testimonial.age} · {testimonial.instrument}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}